{
  "name": "amuvee-client",
  "version": "1.8.0",
  "scripts": {
    "dev": "ng serve --host 0.0.0.0 --port 4200",
    "ng": "ng",
    "start": "ng serve",
    "start:clean": "ng cache clean && ng serve",
    "build": "ng build --base-href=.",
    "build:dev": "ng build --base-href=. --configuration=dev",
    "build:staging": "ng build --base-href=. --configuration=staging",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:watch": "ng test --watch",
    "test:coverage": "ng test --watch=false --coverage",
    "compodoc": "npx compodoc -p tsconfig.doc.json",
    "generate:api": "openapi-generator-cli generate -i ./swagger.json -g typescript-angular -o src/app/shared/api"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.14",
    "@angular/common": "^21.2.14",
    "@angular/compiler": "^21.2.14",
    "@angular/core": "^21.2.14",
    "@angular/forms": "^21.2.14",
    "@angular/platform-browser": "^21.2.14",
    "@angular/platform-browser-dynamic": "^21.2.14",
    "@angular/router": "^21.2.14",
    "@kolkov/angular-editor": "3.0.5",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/angular": "^10.59.0",
    "@types/leaflet": "^1.9.12",
    "amuvee-shared": "*",
    "autoprefixer": "^10.4.20",
    "canvas-confetti": "^1.9.3",
    "font-awesome": "^4.7.0",
    "jwt-decode": "^4.0.0",
    "leaflet": "^1.9.4",
    "ng-multiselect-dropdown": "^1.0.0",
    "ngx-matomo-client": "^9.1.0",
    "postcss": "^8.5.6",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.12",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.14",
    "@angular/cli": "~21.2.14",
    "@angular/compiler-cli": "^21.2.14",
    "@openapitools/openapi-generator-cli": "^2.21.0",
    "@tailwindcss/postcss": "^4.1.13",
    "@types/canvas-confetti": "^1.9.0",
    "@vitest/coverage-v8": "^4.1.8",
    "jsdom": "^29.0.0",
    "prettier": "3.1",
    "typescript": "~5.9.3",
    "vitest": "^4.1.8"
  },
  "optionalDependencies": {
    "@esbuild/darwin-arm64": "0.27.3",
    "@esbuild/darwin-x64": "0.27.3",
    "@esbuild/linux-arm64": "0.27.3",
    "@esbuild/linux-x64": "0.27.3",
    "@esbuild/win32-arm64": "0.27.3",
    "@esbuild/win32-x64": "0.27.3",
    "@rollup/rollup-darwin-arm64": "4.61.1",
    "@rollup/rollup-darwin-x64": "4.61.1",
    "@rollup/rollup-linux-arm64-gnu": "4.61.1",
    "@rollup/rollup-linux-arm64-musl": "4.61.1",
    "@rollup/rollup-linux-x64-gnu": "4.61.1",
    "@rollup/rollup-linux-x64-musl": "4.61.1",
    "@rollup/rollup-win32-arm64-msvc": "4.61.1",
    "@rollup/rollup-win32-x64-gnu": "4.61.1",
    "@rollup/rollup-win32-x64-msvc": "4.61.1",
    "@tailwindcss/oxide-darwin-arm64": "4.3.0",
    "@tailwindcss/oxide-darwin-x64": "4.3.0",
    "@tailwindcss/oxide-linux-arm64-gnu": "4.3.0",
    "@tailwindcss/oxide-linux-arm64-musl": "4.3.0",
    "@tailwindcss/oxide-linux-x64-gnu": "4.3.0",
    "@tailwindcss/oxide-linux-x64-musl": "4.3.0",
    "@tailwindcss/oxide-win32-arm64-msvc": "4.3.0",
    "@tailwindcss/oxide-win32-x64-msvc": "4.3.0",
    "lightningcss-darwin-arm64": "1.32.0",
    "lightningcss-darwin-x64": "1.32.0",
    "lightningcss-linux-arm64-gnu": "1.32.0",
    "lightningcss-linux-arm64-musl": "1.32.0",
    "lightningcss-linux-x64-gnu": "1.32.0",
    "lightningcss-linux-x64-musl": "1.32.0",
    "lightningcss-win32-arm64-msvc": "1.32.0",
    "lightningcss-win32-x64-msvc": "1.32.0"
  }
}
